import { useCallback, useState } from 'react';

import { hooks } from '@febos-io/common';

import { getConfigs } from '../config';

export function useConfigsByParameter({ companyId, parameters, reference, maxLevel = 100 }) {
  const [element, setElement] = useState({});

  const functionCallback = useCallback(
    async (request) => {
      const { configurations } = await request.exec(
        getConfigs({
          companyId,
          parameters,
          reference,
          maxLevel
        })
      );
      setElement(configurations);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [companyId, maxLevel]
  );

  const { loading } = hooks.useEffectRequestCallback(functionCallback);

  const { callback, loading: loadingConfig } = hooks.useRequestCallback(functionCallback);

  return {
    loading: loading || loadingConfig || false,
    callback,
    element
  };
}

export default useConfigsByParameter;
